// extracted by mini-css-extract-plugin
export default {"backButton":"TopBackLink_backButton__0oQs-"};